import React from "react";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import DashboardMockup from "@/components/DashboardMockup";
import FinalCTA from "@/components/FinalCTA";
import { CheckCircle2 } from "lucide-react";
import { useT } from "@/hooks/useT";

export default function PMS() {
  const t = useT();
  const BLOCKS = [
    {
      title: t("Kalendari i Rezervimeve", "Booking Calendar"),
      points: [
        t("Pamja sipas dhomave, kateve ose tipologjisë",   "View by room, floor or type"),
        t("Lëviz rezervimet me 'drag & drop'",              "Drag-and-drop reservations"),
        t("Ngjyra për secilin kanal",                        "A colour for every channel"),
        t("Filtra për statusin",                             "Filters by status"),
      ],
    },
    {
      title: t("Recepsioni", "Front Desk"),
      points: [
        t("Check-in dhe check-out me një klikim",           "One-click check-in and check-out"),
        t("Verifikim i dokumentit të klientit",              "Guest ID verification"),
        t("Faturë automatike",                                "Automatic invoicing"),
        t("Check-in online para mbërritjes",                  "Online check-in before arrival"),
      ],
    },
    {
      title: t("Të dhënat e klientëve", "Guest Profiles"),
      points: [
        t("Historik i qëndrimeve të mëparshme",              "Full history of past stays"),
        t("Preferenca dhe kërkesa speciale",                  "Preferences and special requests"),
        t("Email dhe SMS automatike",                         "Automatic email and SMS"),
        t("Segmentim për fushata",                             "Segmentation for campaigns"),
      ],
    },
    {
      title: t("Faturimi dhe sistemi fiskal", "Billing & Fiscalization"),
      points: [
        t("Fatura në PDF dhe email",                          "Invoices as PDF and via email"),
        t("Disa valuta dhe TVSh",                             "Multi-currency and VAT"),
        t("Lidhje me sistemin fiskal shqiptar",                "Integrated with the Albanian fiscal system"),
        t("Eksport për kontabilitetin",                        "Export for accounting"),
      ],
    },
  ];

  return (
    <>
      <SEO
        title={t("Program për Hotele (PMS) — Sistem Rezervimesh", "Hotel PMS — Reservations System")}
        description={t(
          "PMS-i i Akomoda për hotele dhe apartamente: kalendari i rezervimeve, recepsioni, faturimi, check-in online dhe lidhja me Booking.com, Airbnb e Expedia.",
          "Akomoda's PMS for hotels and apartments: booking calendar, front desk, invoicing, online check-in and integration with Booking.com, Airbnb and Expedia."
        )}
      />
      <PageHeader
        eyebrow={t("PMS · Sistemi i Rezervimeve", "PMS · Reservations System")}
        title={t("Program rezervimesh i bërë për punën reale të hotelit", "A reservation system built for the real work of a hotel")}
        description={t(
          "Një sistem që ekipi juaj e mëson në një ditë: i shpejtë, i thjeshtë dhe i mbushur me ato gjëra që një hotel ka nevojë vërtet — jo me kompleksitet boshe.",
          "A system your team learns in a day: fast, simple, and packed with what a hotel really needs — no bloated complexity."
        )}
        ctas={[
          { to: "/demo",           label: t("Kërko Demo", "Request Demo") },
          { to: "/booking-engine", label: "Booking Engine", variant: "ghost" },
        ]}
        breadcrumb={[
          { label: t("Platforma", "Platform"), to: "/platforma" },
          { label: t("Program për Hotele", "Hotel PMS") },
        ]}
      />

      <section className="bg-surface-1">
        <div className="container-akm py-14 md:py-20">
          <DashboardMockup />
        </div>
      </section>

      <section className="bg-surface-2">
        <div className="container-akm py-14 md:py-20">
          <div className="grid gap-10 md:grid-cols-2">
            {BLOCKS.map((b) => (
              <div key={b.title} className="card-akm">
                <h3 className="h3-akm">{b.title}</h3>
                <ul className="mt-3 space-y-2 text-sm text-ink">
                  {b.points.map((p) => (
                    <li key={p} className="flex items-start gap-2">
                      <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
